/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';
import ThemeSwitch from 'shared/ui/components/main-menu/ThemeSwitch.vue';
import { getCurrentEventIdFromUrl } from 'libs/utils/url';

/**
 * UserMenu component, used to display user contextual menu and information.
 *
 * @example
 * UserMenu(:user="user" :orgId="orgId")
 *
 * @vue-prop {Object} user the current user object.
 * @vue-prop {String} orgId the current organisation ID.
 *
 * @category ui.components.main-menu
 * @exports UserMenu
 * @component
 */
const __vue_script__ = {
    name: 'UserMenu',

    components: { DropdownMenu, ThemeSwitch },

    props: {
        user: {
            type: Object,
            required: true
        },
        orgId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            profileUrl: this.$utils.url.getHomeUrl('/users/me'),
            orgsUrl: this.$utils.url.getHomeUrl('/orgs'),
            supportWidgetShown: false,
            userMenuLabel: this.$i18n.t('main_menu.user.user_menu'),
            supportLabel: this.$i18n.t('main_menu.help.support'),
        };
    },

    created() {
        this.loadSupportWidget();
    },

    methods: {
        /**
         * Did you switch off all the lights?
         */
        async logout() {
            await this.$services.user.logout();
            this.$services.router.redirectToHome(this.$const.ROUTE_LOGIN);
        },

        /**
         * Loads the support framework
         */
        loadSupportWidget() {
            const src = this.$services.support.getIntercomScriptURL();
            if (!src) return;
            const script = document.createElement('script');

            script.src = src;
            script.async = true;

            script.addEventListener('load', () => {
                const hideFunction = () => this.supportWidgetShown = false;
                const showFunction = () => this.supportWidgetShown = true;
                this.$services.support.initIntercom(window.Intercom, showFunction, hideFunction);
            });

            document.querySelector('head').appendChild(script);
        },

        /**
         * Toggles the visibility of the support widget
         */
        toggleSupportWidget() {
            if (!window.Intercom) {
                return;
            }

            if (this.supportWidgetShown) {
                window.Intercom('hide');
            } else {
                window.Intercom('show');

                window.Intercom('trackEvent', 'last-accessed-url', {
                    backstageUrl: `${window.location}`,
                    eid: getCurrentEventIdFromUrl(window.location),
                });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-menu"},[_c('a',{staticClass:"support has-action",attrs:{"aria-label":_vm.supportLabel},on:{"click":_vm.toggleSupportWidget}},[_c('i',{staticClass:"ic-help-chat",attrs:{"slot":"toggler"},slot:"toggler"})]),_c('dropdown-menu',{staticClass:"user",attrs:{"anchor-pos":"sw","aria-label":_vm.userMenuLabel,"force-position":true}},[_c('span',{attrs:{"slot":"toggler"},slot:"toggler"},[_vm._v(_vm._s(_vm.$utils.strings.initials( _vm.user.realname )))]),_c('ul',[_c('li',[_c('a',{attrs:{"href":_vm.profileUrl}},[_vm._v(_vm._s(_vm.user.realname))])]),_c('li',[_c('a',{attrs:{"href":_vm.orgsUrl}},[_vm._v(_vm._s(_vm.$t('main_menu.user.organizations')))])]),_c('li',{staticClass:"separator"}),_c('li',[_c('a',{on:{"click":_vm.logout}},[_c('i',{staticClass:"icon-log-out"}),_vm._v(_vm._s(_vm.$t('main_menu.user.logout')))])])])]),_c('theme-switch')],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "UserMenu.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__